import { NamespaceConsumer, withNamespace, NamespaceShape } from '@ux/namespace-component';
import icons from './icons.json';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Render a UXIcon.
 *
 * @displayName Icon
 * @class Icon
 * @public
 */
class Icon extends NamespaceConsumer {
  render() {
    const style = {};
    const { name, color, size } = this.props;
    const classNames = this.namespace('uxicon', 'uxicon-' + name);

    if (size) style.fontSize = size;
    if (color) style.color = color;

    return (
      <span style={ style } className={ classNames } />
    );
  }
}

/**
 * PropType validation.
 *
 * @type {Object}
 * @public
 */
Icon.propTypes = {
  ...NamespaceShape,

  /** Name of the icon */
  name: PropTypes.oneOf(Object.keys(icons)).isRequired,
  /** Color of the button */
  color: PropTypes.string,
  /** Size of the button */
  size: PropTypes.number
};

export default withNamespace(Icon);



// WEBPACK FOOTER //
// ./node_modules/@ux/icon/index.js